import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import LiveSignalCenter from './components/LiveSignalCenter';

// Components
import Navbar from './components/Navbar';
import PrivateRoute from './components/PrivateRoute';

// Pages
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import LiveMatches from './pages/LiveMatches';
import LiveCouponPage from './pages/LiveCouponPage';
import Analysis from './pages/Analysis';
import BasketballPage from './pages/BasketballPage';
import BasketballLive from './pages/BasketballLive';
import AdminPanel from './pages/AdminPanel';
import AdminUsers from './pages/AdminUsers';
import RiskyAnalysis from './pages/RiskyAnalysis';
import PremiumCoupons from './pages/PremiumCoupons';
import PremiumPreview from './pages/PremiumPreview';
import AccountDeletionRequestPage from './pages/AccountDeletionRequestPage';
import PremiumOpportunitiesPage from './premium-opportunities/pages/PremiumOpportunitiesPage';
import WinningArchivePage from './winning-archive/pages/WinningArchivePage';
import WinningPremiumCouponsPage from './winning-premium-coupons/pages/WinningPremiumCouponsPage';
import LiveSupportWidget from './chatbot/components/LiveSupportWidget';

function AppShell() {
  const location = useLocation();
  const isLiveDashboardRoute = location.pathname === '/live';
  const routeClassName = location.pathname === '/live'
    ? 'route-live-analysis'
    : location.pathname === '/analysis'
      ? 'route-ai-analysis'
      : location.pathname === '/basketball'
        ? 'route-basketball-analysis'
        : location.pathname === '/premium-coupons'
          ? 'route-premium-analysis'
          : '';

  return (
    <div className="app">
      <Navbar />
      <main className={`main-content ${isLiveDashboardRoute ? 'live-dashboard-container' : ''} ${routeClassName}`.trim()}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/" element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } />
          <Route path="/live" element={
            <PrivateRoute requirePremium={true}>
              <LiveMatches />
            </PrivateRoute>
          } />
          <Route path="/analysis" element={
            <PrivateRoute requirePremium={true}>
              <Analysis />
            </PrivateRoute>
          } />
          <Route path="/basketball" element={
            <PrivateRoute requirePremium={true}>
              <BasketballPage />
            </PrivateRoute>
          } />
          <Route path="/basketball-live" element={
            <PrivateRoute requirePremium={true}>
              <BasketballLive />
            </PrivateRoute>
          } />
          <Route path="/live-coupon" element={
            <PrivateRoute requirePremium={true}>
              <LiveCouponPage />
            </PrivateRoute>
          } />
          <Route path="/premium-preview" element={
            <PrivateRoute>
              <PremiumPreview />
            </PrivateRoute>
          } />
          <Route path="/account-deletion-request" element={
            <PrivateRoute>
              <AccountDeletionRequestPage />
            </PrivateRoute>
          } />
          <Route path="/winning-archive" element={
            <PrivateRoute>
              <WinningArchivePage />
            </PrivateRoute>
          } />
          <Route path="/winning-premium-coupons" element={
            <PrivateRoute>
              <WinningPremiumCouponsPage />
            </PrivateRoute>
          } />
          <Route path="/risky-analysis" element={
            <PrivateRoute requirePremium={true}>
              <RiskyAnalysis />
            </PrivateRoute>
          } />
          <Route path="/premium-coupons" element={
            <PrivateRoute requirePremium={true}>
              <PremiumCoupons />
            </PrivateRoute>
          } />
          <Route path="/premium-opportunities" element={
            <PrivateRoute requirePremium={true}>
              <PremiumOpportunitiesPage />
            </PrivateRoute>
          } />
          <Route path="/admin" element={
            <PrivateRoute requireAdmin={true}>
              <AdminPanel />
            </PrivateRoute>
          } />
          <Route path="/admin/users" element={
            <PrivateRoute requireAdmin={true}>
              <AdminUsers />
            </PrivateRoute>
          } />
        </Routes>
      </main>
      <LiveSupportWidget />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppShell />
        <LiveSignalCenter />
      </Router>
    </AuthProvider>
  );
}

export default App;
